import Vue from 'vue'
import App from './App.vue'
import '@fontsource/noto-sans-sc/chinese-simplified-400.css'
import '@fontsource/noto-sans-sc/chinese-simplified-700.css'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
